const SponsorsDatas = [
    {
      link: 'https://artistemartial.com/',
      image: require('../img/artistemartial.jpg'),
      alt: "Artiste Martial",
      title: "Artiste Martial",
    },
  ]
export default SponsorsDatas;